export default {
  Starterkit: 'Starterkit',
  Dashboards: 'Dashboards',
  Classic: 'Classic ',
  Analytical: 'Analytical ',
  Ecommerce: 'Ecommerce ',
  General: 'General ',
  Apps: 'Apps',
  Chats: 'Chats',
  Calendar: 'Calendar',
  ContactList: 'Contact List',
  ContactGrid: 'Contact Grid',
  Email: 'Email',
  Todo: 'Todo',
  UiElements: 'Ui Elements',
  VuesaxComponents: 'Vuesax Components',
  Alert: 'Alert',
  Avatar: 'Avatar',
  Breadcrumb: 'Breadcrumb',
  Buttons: 'Buttons',
  Cards: 'Cards',
  Chips: 'Chips',
  Collapse: 'Collapse',
  Dialog: 'Dialog',
  Divider: 'Divider',
  Dropdown: 'Dropdown',
  List: 'List',
  Loading: 'Loading',
  Navbar: 'Navbar',
  Notification: 'Notification',
  Numberinput: 'Number input',
  Pagination: 'Pagination',
  Popup: 'Popup',
  Progress: 'Progress',
  Sidebar: 'Sidebar',
  Slider: 'Slider',
  Tabs: 'Tabs',
  Tooltip: 'Tooltip',
  Forms: 'Forms',
  FormElements: 'Form Elements',
  Checkboxes: 'Checkboxes',
  Datepicker: 'Datepicker',
  Input: 'Input',
  Radio: 'Radio',
  Select: 'Select',
  Switch: 'Switch',
  Textarea: 'Textarea',
  Upload: 'Upload',
  FormLayouts: 'Form Layouts',
  FormAction: 'Form Action',
  FormBasic: 'Form Basic',
  FormHorizontal: 'Form Horizontal',
  FormWizard: 'Form Wizard',
  DragnDrop: 'Drag n Drop',
  TableExamples: 'Table Examples',
  Basictable: 'Basic table',
  Editabletable: 'Editable table',
  ExpandDatatable: 'Expand Datatable',
  Filtertable: 'Filter table',
  Miscellaneoustable: 'Miscellaneous table',
  Paginationtable: 'Pagination table',
  Selectedtable: 'Selected table',
  SSTtable: 'SST table',
  Charts: 'Charts',
  ApexCharts: 'ApexCharts',
  ChartJs: 'ChartJs',
  Icons: 'Icons',
  MaterialIcons: 'Material Icons',
  ThemifyIcons: 'Themify Icons',
  ExtraComponents: 'Extra Components',
  Carousel: 'Carousel',
  Widgets: 'Widgets',
  AppWidgets: 'App Widgets',
  DataWidgets: 'Data Widgets',
  lang: `Lenguaje`,
  es: `Español`,
  en: `English`,
  spanish: `Español`,
  english: `English`,
  name: `Nombre`,
  login: `Iniciar sesión`,
  email: `Correo electrónico`,
  password: `Contraseña`,
  confirm_password: `Confirmar contraseña`,
  access_pin: `PIN de acceso`,
  confirm_access_pin: `Confirmar PIN`,
  administrator: `Administrador`,
  logout: `Cerrar sesión`,
  settings: `Configuración`,
  active: `Activo | Activos`,
  inactive: `Inactivo | Inactivos`,
  total: `Totales`,
  new: `Nuevo`,
  search: `Buscar`,
  city: `Ciudad`,
  created: `Creado`,
  restaurant: `Restaurante`,
  phone: `Teléfono`,
  save: `Guardar`,
  delete: `Eliminar`,
  edit: `Editar`,
  user: `Usuario | Usuarios`,
  without_email: `No tiene correo`,
  without_phone: `No tiene teléfono`,
  has_been_created: `"{who}" ha sido creado`,
  has_been_removed: `"{who}" ha sido eliminado`,
  has_been_updated: `"{who}" ha sido actualizado`,
  new_user: `Nuevo usuario`,
  edit_user: `Editar usuario`,
  close: 'Cerrar',
  create: `Crear`,
  url: `Url`,
  url_precompro: 'Url Precompro.com',
  url_alternative: 'Url alternativa',
  subdomain: `Subdominio`,
  new_restaurant: `Nuevo restaurante`,
  suggested: `Sugerido`,
  not_reset_pin: `No resetear PIN`,
  reset_pin: `Resetear PIN`,
  not_reset_password: `No resetear contraseña`,
  reset_password: `Resetear contraseña`,
  white_label: 'Marca blanca',
  published: 'Publicado',
  information: 'Información',
  short_description: 'Description corta',
  description: 'Descripción',
  location: 'Ubicación',
  address: 'Dirección',
  headquarter: 'Sede',
  keywords: 'Palabras clave',
  price: 'Precio',
  maximun_cost_per_person: 'Máximo costo por persona',
  cost_type: 'Tipo de costo',
  food: 'Comida',
  type: 'Tipo',
  chef: 'Chef',
  service: 'Servicio | Servicios',
  requirements: 'Requerimientos',
  booking_settings: 'Configuración de la reserva',
  book_in_advance: 'Anticipación',
  rotation_time: 'Rotación',
  update_time: 'Actualización',
  cancelation_time: 'Cancelación',
  people_per_booking: 'Personas por reserva',
  presale_from: 'Precompra desde',
  presale_cost: 'Valor precompra',
  maximum_booking_per_hour: 'Máx. reservas / hora',
  hour: 'Hora | Horas',
  opening_hours: 'Horario de atención',
  presales_hours: 'Horario de precompras',
  free_presales_hours: 'Horario de reservas gratuitas',
  distribution: 'Distribución',
  section: 'Sección',
  not_items: 'No hay elementos',
  table: 'Mesa | Mesas',
  new_table: 'Nueva mesa',
  edit_table: 'Editar mesa',
  merged: 'Combinaciones',
  new_merge: 'Nueva unión',
  file: 'Archivo',
  upload_file: 'Subir archivo',
  download_file: 'Bajar archivo',
  download_template: 'Bajar plantilla',
  processing: 'Procesando ...',
  min: 'Min',
  max: 'Max',
  minimum: 'Mínimo',
  maximum: 'Máximo',
  private: 'Privado',
  rounded: 'Redondeado',
  priority: 'Prioridad',
  availability: 'Disponibilidad',
  customer: 'Cliente',
  hello: 'Hola',
  click_to_change_logo: 'Clic para cambiar logo',
  click_to_change_image: 'Clic para cambiar imagen',
  you_have_a_new_reservation: 'Te han hecho una nueva reserva',
  your_reservation_at: 'Tu reserva en',
  has_been_successful: 'ha sido realizada con éxito',
  facebook: 'Facebook',
  twitter: 'Twitter',
  instagram: 'Instagram',
  show_in_precompro: 'Mostrar en Precompro',
  web: 'Web',
  select_a_cost_type: 'Elija un tipo de costo',
  costless: 'Gratuito',
  presales: 'Precompras',
  opening: 'Apertura',
  show_distribution: 'Mostrar distribución',
  show_list: 'Mostrar lista',
  hide_address: 'Ocultar dirección',
  disable_vat: 'Deshabilitar IVA',
  disable_confirmation: 'Deshabilitar confirmación',
  disable_analytics: 'Deshabilitar Analíticas',
  toggle_view: 'Cambiar vista',
  contact_email: 'Correo de contacto',
  event_email: 'Correo de eventos',
  event: `evento`,
  precompro_description: 'Descripción para Precompro.com',
  website: 'Sitio web',
  add_section: 'Agregar sección',
  edit_section: 'Editar sección',
  select_a_city: 'Elija una ciudad',
  total_sms_send: 'SMS enviados',
  active_sms: 'Activar SMS',
  recharge_list_sms: 'Información de recargas',
  list_send_sms: 'Información de mensajes enviados',
  config_module_sms: 'Configuración SMS',
  sms_cost: 'Costo SMS',
  limit_sms: 'Total SMS',
  total_sms_pending: 'SMS disponibles',
  recharge: 'Recargar',
  recharge_add: 'Nueva Recarga',
  poll: 'Encuesta',
  new_poll: 'Nueva Encuesta',
  add_question_poll: 'Agregar Preguntas',
  enabled_waiting_list: 'Activar Lista de Espera',
  is_bar: 'Es bar',
  enabled_identity_document: 'Solicitar Documento Identidad',
  save_value_consumed: 'Guardar Consumo',
  anticipation_time_user: 'Tiempo guarda reserva',
  shared: 'Compartida',
  is_event_table: 'Mesa Evento',
  people: 'Personas',
  errors: {
    request: `Lo siento, ha ocurrido un error al intentar procesar tu pretición`,
    form: `El formulario no es válido! Por favor verifique los campos.`,
  },
}
